import { type LogicalType } from '@blaze-shared/api-contracts-domain';

import { type BaseAiElementDefinition, type ElementContext } from '../../../ai/models/ai.model';
import { type Condition } from '../../../ai/models/condition';

export interface CollapsibleContainerDefinition
  extends BaseAiElementDefinition<'collapsibleContainer'> {
  iconName?: string;
  title?: string;
  showCollapseIcon?: boolean;
  reverseCollapseIconWhenClosed?: boolean;
  openByDefault?: boolean;
  filters?: CollapsibleContainerFilters;
  children?: BaseAiElementDefinition<any>[];
}

export interface CollapsibleContainerContext extends ElementContext<'collapsibleContainer'> {
  element: CollapsibleContainerDefinition;
}

export interface CollapsibleContainerFilters {
  type: OpenCloseFilterType;
  conditions: Condition[];
  logicalOperator: LogicalType;
}

export enum OpenCloseFilterType {
  OpenWhen = 'OpenWhen',
  CloseWhen = 'CloseWhen',
}
